import React, { useCallback, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import { HtmlBlockContainer } from './styles';
import { COMPLEX_DOCUMENT_CONTEXT_KEYS, useDocumentContext } from '../../context/complexDocumentContext';
import {
  useArtboardContext,
  CONTEXT_KEYS,
  TEMPLATE_TYPE,
} from '../../context/complexArtboardContext';
import { dummyCallback, HTML_BLOCK } from '../../utils/complexDocumentConstants';

const HtmlBlockRenderer = props => {
  const {
    editable,
    itemUUID,
    parentUUID,
    type,
    isMobileView = false,
    onClickBlockSelection = dummyCallback,
    getElementStyles,
  } = props;
  const blockRef = useRef(null);
  const customSelector = useCallback(store => store[itemUUID], []);
  const [htmlBlock] = useDocumentContext(customSelector, `htmlBlock-${itemUUID}`);

  const dataSetSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.DATA_SET], []);
  const [dataSet] = useDocumentContext(dataSetSelector, `htmlBlock-${itemUUID}`);

  const interactiveDesignSelector = useCallback(store => store[CONTEXT_KEYS.IS_INTERACTIVE_DESIGN], []);
  const [isInteractiveDesign] = useArtboardContext(interactiveDesignSelector, `HtmlBlockRenderer`);

  const htmlContent = dataSet?.[htmlBlock.variableContract[0].name] ?? null;

  const artboardContextSelector = useCallback(
    store => ({
      currentBlock: store[CONTEXT_KEYS.CURRENT_BLOCK] === itemUUID,
      selectedBlocks: store[CONTEXT_KEYS.SELECTED_BLOCKS],
      isDocumentOrFlowDesign: [TEMPLATE_TYPE.DOCUMENT, TEMPLATE_TYPE.FLOW].includes(
        store[CONTEXT_KEYS.CURRENT_DESIGN],
      ),
    }),
    [],
  );
  const [
    { currentBlock, selectedBlocks, isDocumentOrFlowDesign }
  ] = useArtboardContext(artboardContextSelector, `htmlBlock-${itemUUID}`);

  const handleSingleclick = e => {
    if (editable && isDocumentOrFlowDesign && !currentBlock) {
      if (e.ctrlKey || e.metaKey) {
        onClickBlockSelection({ itemUUID, parentUUID });
      }
    }
  };

  const handleDoubleClick = () => {
    if (editable) {
      const target = document.getElementById(`settings-tooltip-${itemUUID}`);
      target && target.click();
    }
  };

  const blockSelected = selectedBlocks.includes(itemUUID);

  return (
    <HtmlBlockContainer
      id={itemUUID}
      className={isInteractiveDesign ? '' :'empty'}
      currentBlock={currentBlock}
      style={{
        height: isInteractiveDesign && htmlContent ? 'auto' : htmlBlock.style.height * (isMobileView ? 0.66 : 1),
        background: blockSelected ? '#ACCEF7' : htmlBlock.style.backgroundColor,
      }}
      onClick={handleSingleclick}
      onDoubleClick={handleDoubleClick}
      onMouseMove={e =>
        (editable || isInteractiveDesign) && !currentBlock && getElementStyles && getElementStyles(e, itemUUID)
      }
    >
      {!isInteractiveDesign && type === HTML_BLOCK && 'HTML </>  '}
      {isInteractiveDesign && htmlContent && <div dangerouslySetInnerHTML={{ __html: htmlContent }} />}

      <div
        ref={blockRef}
        id={`${itemUUID}-ref`}
        style={{
          position: 'absolute',
          zIndex: -1,
          pointerEvents: 'none',
          top: 0,
          height: htmlBlock.style.height,
          width: '100%',
        }}
      />
    </HtmlBlockContainer>
  );
};

export default React.memo(withTranslation('COMPLEX_PAGE_OPTIONS')(HtmlBlockRenderer));
